module.exports = __webpack_public_path__ + "img/menu-message-yellow.e14f7a2a.svg";